import { useTranslation } from 'react-i18next';

import { LoadingButton } from '@mui/lab';
import { Box, Button, Grid, styled } from '@mui/material';

const StyledEditFooter = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 30px 0;
  width: 100%;
  background: white;
`;

type Props = {
  onCancelClick: () => void;
  onClickSave?: (e: React.MouseEvent) => void;
  submitDisabled: boolean;
};

export default function EditFooter({
  onCancelClick,
  submitDisabled,
  onClickSave
}: Props) {
  const { t } = useTranslation();
  return (
    <StyledEditFooter
      sx={{
        zIndex: 30,
        borderTop: 1,
        borderColor: 'lightGrey',
        background: 'white'
      }}
    >
      <Grid xs={6} mr={2} item={true}>
        <Button variant="text" color="dark" onClick={onCancelClick}>
          {t('cancel')}
        </Button>
      </Grid>
      <Grid xs={6} item={true}>
        <LoadingButton
          type="submit"
          variant="contained"
          autoFocus
          color="dark"
          disabled={submitDisabled}
          onClick={onClickSave}
        >
          {t('save')}
        </LoadingButton>
      </Grid>
    </StyledEditFooter>
  );
}
